document.addEventListener('DOMContentLoaded',function(){
  var toggle=document.querySelector('.menu-toggle');
  var mobileNav=document.querySelector('.mobile-nav');
  if(toggle&&mobileNav){
    toggle.addEventListener('click',function(){mobileNav.classList.toggle('open')});
  }
  function updateCartCount(){
    fetch('/cart.js').then(function(r){return r.json()}).then(function(d){
      var els=document.querySelectorAll('.cart-count');
      els.forEach(function(el){el.textContent=d.item_count||0});
    }).catch(function(){});
  }
  updateCartCount();
  document.querySelectorAll('.btn-cart').forEach(function(btn){
    btn.addEventListener('click',function(e){
      e.preventDefault();
      var id=btn.dataset.variant;
      if(!id)return;
      var orig=btn.textContent;
      btn.textContent='Agregando...';
      btn.disabled=true;
      fetch('/cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({id:parseInt(id),quantity:1})
      }).then(function(){
        btn.textContent='Agregado ✓';
        btn.style.background='#27500A';
        updateCartCount();
        setTimeout(function(){
          btn.textContent=orig;
          btn.style.background='';
          btn.disabled=false;
        },2000);
      }).catch(function(){
        btn.textContent='Error, intenta de nuevo';
        btn.disabled=false;
        setTimeout(function(){btn.textContent=orig},2000);
      });
    });
  });
});
